import React from 'react';
import { BACKEND_ROOT_URL } from '../utils/urls.js';

const EmailTemplates = () => {
    const iframeSrc = `${BACKEND_ROOT_URL}/email-templates`;

    return (
        <div className="container mx-auto p-4 h-full">
            <h1 className="text-3xl font-bold text-gray-800 mb-6">
                Email Subscription Templates
            </h1>
            <div className="bg-white shadow-lg rounded-lg p-2" style={{ height: '80vh' }}>
                <iframe
                    src={iframeSrc}
                    title="Email Templates"
                    style={{ width: '100%', height: '100%', border: 'none' }}
                />
            </div>
        </div>
    );
};

export default EmailTemplates;